import { FULL_HD, HD } from '@bedrock-rdk/constants';
import {
  USAGE_TERMS_PATH,
  PRIVACY_POLICY_PATH,
  SUBSCRIPTION_TERMS_PATH,
  LEGAL_CONDITIONS_PATH,
  SETTINGS_PATH,
  EXPIRED_SUBSCRIPTION_PATH,
  VIDEO_PATH,
  LIVE_PATH,
} from '../../../routes/routes.utils';

export const CONTENT_GAP = {
  [HD]: 16,
  [FULL_HD]: 24,
};

export const RESTRICTED_PATHS = [
  USAGE_TERMS_PATH,
  PRIVACY_POLICY_PATH,
  SUBSCRIPTION_TERMS_PATH,
  LEGAL_CONDITIONS_PATH,
  SETTINGS_PATH,
  EXPIRED_SUBSCRIPTION_PATH,
  VIDEO_PATH,
  LIVE_PATH,
];
